import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "pb-10 pb-lg-12" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "fw-bolder text-dark" }, "Research Question")
], -1)
const _hoisted_5 = { class: "fv-row mb-10" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label required" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "" }, "1. What is your research question(s)?")
], -1)
const _hoisted_7 = { class: "mb-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6 required" }, [
  /*#__PURE__*/_createTextVNode("2. What is the research design? "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "Definition: The research design of human subject research refers to the overall plan or strategy outlining how data will be collected and analyzed to address specific research questions or hypotheses."
  })
], -1)
const _hoisted_9 = {
  key: 0,
  class: "fv-row mb-10"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "2.1 Please describe"),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true"
  })
], -1)
const _hoisted_11 = { class: "mb-6 d-flex flex-stack" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6" }, [
  /*#__PURE__*/_createTextVNode(" 3. Is an intervention a part of the research? "),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "Definition: ''intervention'' refers to any deliberate action, treatment, manipulation, or condition introduced by the researcher to study its effects on the participants' health, behavior, or outcomes. E.g., education session, training, treatment, etc."
  })
], -1)
const _hoisted_13 = { class: "form-check form-switch form-check-custom form-check-solid mb-6" }
const _hoisted_14 = { class: "form-check-label fw-bold text-gray-400" }
const _hoisted_15 = {
  key: 1,
  class: "fv-row mb-10"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "3.1 Please summarize the intervention")
], -1)
const _hoisted_17 = { class: "fv-row mb-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center form-label" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "4. List and describe all outcome measures that will be used to gather data from subjects. Attach all outcome measures/data collection instruments to this application."),
  /*#__PURE__*/_createElementVNode("i", {
    class: "fas fa-exclamation-circle ms-2 fs-7",
    "data-bs-toggle": "popover",
    "data-bs-trigger": "hover",
    "data-bs-html": "true",
    title: "Definition: ''Outcome Measures'' in human subject research are tools, such as surveys, questionnaires, interviews, or physiological assessments, used to gather information from subjects for the purpose of study analysis and interpretation"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_IrbGptSection = _resolveComponent("IrbGptSection")!
  const _component_editor = _resolveComponent("editor")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"]),
      _createVNode(_component_IrbGptSection)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_editor, {
          for: "purpose",
          initialValue: "",
          modelValue: _ctx.step1.question,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step1.question) = $event)),
          "api-key": _ctx.currentEditorToken,
          licenseKey: "gpl",
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "question",
          for: "question",
          initialValue: "",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "Type Purpose",
          modelValue: _ctx.step1.question,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step1.question) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "question",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", null, [
            (_openBlock(), _createBlock(_component_el_select, {
              class: "form-select-solid",
              placeholder: "Select option",
              name: "researchDesign",
              "data-control": "researchDesign",
              modelValue: _ctx.step1.researchDesign,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step1.researchDesign) = $event)),
              key: _ctx.step1.researchDesign
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "Subject interviews or focus group",
                  value: "Subject interviews or focus group"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Subject interviews or focus group")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "One-time survey",
                  value: "One-time survey"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("One-time survey")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "One group pre-test post-test design",
                  value: "One group pre-test post-test design"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("One group pre-test post-test design")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Randomized Control Trial",
                  value: "Randomized Control Trial"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Randomized Control Trial")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Case Study",
                  value: "Case Study"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Case Study")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_option, {
                  label: "Others, please specify",
                  value: "Others, please specify"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Others, please specify")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]))
          ])
        ]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "researchDesign",
          initialValue: "",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "How it will be record?",
          modelValue: _ctx.step1.researchDesign,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step1.researchDesign) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "researchDesign",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ]),
      (_ctx.step1.researchDesign == 'Others, please specify')
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Field, {
              type: "text",
              name: "otherResearchDesign",
              for: "otherResearchDesign",
              initialValue: "",
              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              placeholder: "Other research design",
              modelValue: _ctx.step1.otherResearchDesign,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step1.otherResearchDesign) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "otherResearchDesign",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("label", _hoisted_13, [
          _createVNode(_component_Field, {
            type: "checkbox",
            class: "form-check-input",
            name: "isAnyIntervention",
            value: "1",
            modelValue: _ctx.step1.isAnyIntervention,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step1.isAnyIntervention) = $event))
          }, null, 8, ["modelValue"]),
          _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.step1.isAnyIntervention == "1" ? "Yes" : "No"), 1)
        ])
      ]),
      (_ctx.step1.isAnyIntervention == '1')
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_editor, {
              for: "sumarizeIntervention",
              initialValue: "",
              modelValue: _ctx.step1.sumarizeIntervention,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step1.sumarizeIntervention) = $event)),
              "api-key": _ctx.currentEditorToken,
              licenseKey: "gpl",
              init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
            }, null, 8, ["modelValue", "api-key"]),
            _createVNode(_component_Field, {
              type: "hidden",
              name: "sumarizeIntervention",
              for: "sumarizeIntervention",
              class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
              modelValue: _ctx.step1.sumarizeIntervention,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step1.sumarizeIntervention) = $event))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ErrorMessage, {
              name: "sumarizeIntervention",
              class: "fv-plugins-message-container invalid-feedback"
            })
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createVNode(_component_editor, {
          for: "outcomes",
          initialValue: "",
          modelValue: _ctx.step1.outcomes,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step1.outcomes) = $event)),
          licenseKey: "gpl",
          "api-key": _ctx.currentEditorToken,
          init: {
            height: 200,
            menubar: false,
            plugins: [
              'advlist autolink lists link image charmap',
              'searchreplace visualblocks code fullscreen',
              'print preview anchor insertdatetime media',
              'paste code help wordcount table',
            ],
            toolbar:
              'undo redo | formatselect | bold italic |         alignleft aligncenter alignright |         bullist numlist outdent indent | help',
          }
        }, null, 8, ["modelValue", "api-key"]),
        _createVNode(_component_Field, {
          type: "hidden",
          name: "outcomes",
          for: "outcomes",
          initialValue: "",
          class: "form-control form-control-lg form-control-solid mb-3 mb-lg-0",
          placeholder: "Type Purpose",
          modelValue: _ctx.step1.outcomes,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.step1.outcomes) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_ErrorMessage, {
          name: "outcomes",
          class: "fv-plugins-message-container invalid-feedback"
        })
      ])
    ])
  ]))
}